namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class FormatDateEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "DD/MM/YYYY", text: "05/07/2022" });
            this.addItem({ id: "DD-MM-YYYY", text: "05-07-2022" });
            this.addItem({ id: "DD/MMM/YYYY", text: "05/Jul/2022" });
            this.addItem({ id: "DD-MMM-YYYY", text: "05-Jul-2022" });
            this.addItem({ id: "dddd, MMMM D, YYYY", text: "Monday, July 5, 2022" });
            this.addItem({ id: "MMMM D, YYYY", text: "July 5, 2022" });
            this.addItem({ id: "D MMM, YYYY", text: "5 July, 2022" });
            this.addItem({ id: "CustomDate", text: "Custom Date" });
        }
    }
}